import React from 'react';

const BS_GridSmall = () => {
    return (
        <div>
            <h1>BS_GridSmall Component</h1>
            <p>Content coming soon...</p>
        </div>
    );
}

export default BS_GridSmall;
